import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { DimonaStatus } from './dimona-status.interface';

export class DimonaStatusService {
   async getDimonaStatuses() {
      const response = await http.get<Array<DimonaStatus>>(`/dimona-statuses`, cacheFirstConfig);
      return response.data;
   }

   async getDimonaStatus() {
      throw Error('Method not implemented');
   }

   async postDimonaStatus() {
      throw Error('Method not implemented');
   }

   async putDimonaStatus() {
      throw Error('Method not implemented');
   }

   async deleteDimonaStatus() {
      throw Error('Method not implemented');
   }
}
